import { motion } from "framer-motion";
import { BadgePercent, ArrowDownRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import { useSettings } from "@/lib/SettingsContext";

export default function OfferBanner() {
  const settings = useSettings();
  const offer = settings.offer || {};

  return (
    <section data-testid="offer-banner" className="px-6 py-10 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 overflow-hidden rounded-[1.75rem] border border-[#D4AF37]/40 bg-[#F4ECE1] px-8 py-8 lg:flex-row lg:items-center lg:px-12"
      >
        <div
          aria-hidden
          className="absolute -right-16 -top-16 h-48 w-48 rounded-full border-[24px] border-[#D4AF37]/15"
        />
        <div className="flex items-start gap-5">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#D4AF37]/20">
            <BadgePercent className="h-5 w-5 text-[#8a6d1a]" strokeWidth={1.75} />
          </span>
          <div>
            <p className="font-serif text-2xl font-light text-[#121A16] lg:text-3xl">
              {offer.title}
            </p>
            <p className="mt-1 text-sm text-[#4A5A52]">{offer.subtitle}</p>
          </div>
        </div>
        <button
          data-testid="offer-claim-button"
          onClick={() => scrollToSection("#booking")}
          className="group flex shrink-0 items-center gap-2 rounded-full bg-[#0F382A] px-7 py-3.5 text-sm font-semibold text-[#FAF8F5] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#1B523F]"
        >
          Claim the offer
          <ArrowDownRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
        </button>
      </motion.div>
    </section>
  );
}
